import { useEffect } from 'react';
import {
  ComprehensiveConsent,
  TransactionAgreement,
  TransactionDescription,
  MedicalInterview,
  ConfirmationConsent,
  IntroductionOtherHospital
} from '../routes';
import { useActiveStep } from '../hooks/useActiveStep';
import { fetchAuthSession } from 'aws-amplify/auth';
import { getPatient } from '@/graphql/queries';
import { executeQuery } from '@/client/graphql';
import { GetPatientQuery } from '@/API';

export function MedicalConsultation() {
  const { activeStep, setActiveStep } = useActiveStep();

  useEffect(() => {
    (async () => {
      try {
        const session = await fetchAuthSession();
        const res = await executeQuery<GetPatientQuery>(getPatient, { id: session.userSub as string }, 'userPool');
        const patient = res?.getPatient;
        if (patient != null) {
          const houkatuDoui = patient.houkatuDoui;
          if (houkatuDoui != null) {
            if (houkatuDoui) {
              setActiveStep('MedicalInterview');
            } else {
              setActiveStep('ComprehensiveConsent');
            }
          }
        }
      } catch (e) {
        console.error(e);
      }
    })();
  }, []);

  switch (activeStep) {
    case 'ComprehensiveConsent':
      return <ComprehensiveConsent />;
    case 'ConfirmationComprehensiveConsent':
      return <ConfirmationConsent />;
    case 'TransactionDescription':
      return <TransactionDescription />;
    case 'TransactionAgreement':
      return <TransactionAgreement />;
    case 'ConfirmationTransactionAgreement':
      return <ConfirmationConsent />;
    case 'IntroductionOtherHospital':
      return <IntroductionOtherHospital />;
    case 'MedicalInterview':
      return <MedicalInterview />;
    case 'Completed':
      return 'medicalConsultation Completed';
  }
}
